import { render } from "./SrchClassification.vue?vue&type=template&id=7cb65db8"
import script from "./SrchClassification.vue?vue&type=script&lang=js"
export * from "./SrchClassification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__